import ServicesSection from '../components/ServicesSection.jsx';

export default function ServicesPage() {
  return <ServicesSection titleTag="h1" />;
}
